import React, { useState } from "react";

function MortgageCalculator() {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [downPayment, setDownPayment] = useState(50000);
  const [interestRate, setInterestRate] = useState(4.0);
  const downPerc = Math.round((downPayment / loanAmount) * 100);
  const [loanTerm, setLoanTerm] = useState(30);

  const principal = loanAmount - downPayment;
  const monthlyInterestRate = interestRate / 100 / 12;
  const numberOfPayments = loanTerm * 12;

  const monthlyPayment =
    monthlyInterestRate === 0
      ? principal / numberOfPayments
      : (principal *
          monthlyInterestRate *
          Math.pow(1 + monthlyInterestRate, numberOfPayments)) /
        (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);

  return (
    <>
      <div className="text-left calculator-container">
        <h4 className="calculator-title">Calculate your mortgage repayments</h4>
        {/* Purchase Price Slider */}
        <div className="slider-container">
          <div className="slider-label">Purchase Price</div>
          <div className="slider-amount">
            {" "}
            {loanAmount.toLocaleString("en-AE", {
              style: "currency",
              currency: "AED",
              maximumFractionDigits: 0,
            })}
          </div>
          <input
            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-green-500
             [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:bg-[#173d73]
             [&::-webkit-slider-thumb]:rounded-full"
            id="purchasePrice"
            type="range"
            min="50000"
            max="1000000"
            step="10000"
            value={loanAmount}
            onChange={(e) => setLoanAmount(Number(e.target.value))}
          />
          <div className="slider-values">
            <span>AED 500,000</span>
            <span>AED 5,000,000</span>
          </div>
        </div>
        {/* Down Payment Slider */}
        <div className="slider-container">
          <div className="slider-label">Down Payment</div>
          <div className="slider-amount">
            {downPayment.toLocaleString("en-AE", {
              style: "currency",
              currency: "AED",
              maximumFractionDigits: 0,
            })}
          </div>
          <input
            type="range"
            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-green-500
             [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:bg-[#173d73]
             [&::-webkit-slider-thumb]:rounded-full"
            id="downPayment"
            min={100000}
            max={600000}
            step={10000}
            defaultValue={200000}
            value={downPayment}
            onChange={(e) => setDownPayment(Number(e.target.value))}
          />
          <div className="slider-values">
            <span>AED 100,000</span>
            <span>{downPerc}%</span>
          </div>
        </div>
        {/* Loan Period Slider */}
        <div className="slider-container">
          <div className="slider-label">Loan Period</div>
          <div className="slider-amount">{loanTerm}</div>
          <input
            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-green-500
             [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:bg-[#173d73]
             [&::-webkit-slider-thumb]:rounded-full"
            id="loanPeriod"
            type="range"
            min="5"
            max="40"
            step="1"
            value={loanTerm}
            onChange={(e) => setLoanTerm(Number(e.target.value))}
          />
          <div className="slider-values">
            <span>1 year</span>
            <span>40 years</span>
          </div>
        </div>
        {/* Interest Rate Slider */}
        <div className="slider-container">
          <div className="slider-label">Interest Rate:</div>
          <div className="slider-amount">{interestRate}</div>
          <input
            type="range"
            className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-green-500
             [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:bg-[#173d73]
             [&::-webkit-slider-thumb]:rounded-full"
            id="interestRate"
            min={0}
            max={10}
            step="0.01"
            defaultValue="3.89"
            value={interestRate}
            onChange={(e) => setInterestRate(Number(e.target.value))}
          />
          <div className="slider-values">
            <span>1%</span>
            <span>20%</span>
          </div>
        </div>
        {/* Monthly Repayment */}
        <div className="monthly-repayment">
          <div className="repayment-label">Monthly repayment</div>
          <div className="repayment-amount">
            AED{" "}
            {Math.round(monthlyPayment).toLocaleString("en-AE", {
              style: "currency",
              currency: "AED",
              maximumFractionDigits: 0,
            })}
          </div>
          <div className="disclaimer">
            * Estimated initial monthly payments based on a AED 1,000,000
            purchase price with a 3.89% fixed interest rate.
          </div>
        </div>
      </div>
    </>
  );
}

export default MortgageCalculator;
